import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const offsetHeight = (params.p_r_s === 1) ? -0.15 : 0;
    
    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(params.lean_p_d / 2 , 0);
        model.lineTo(params.lean_p_d / 2 , sideWallCloseSize);
        model.lineTo(params.lean_p_d / 2 + 0.26, sideWallCloseSize);
        model.lineTo(params.lean_p_d / 2 + 0.26, 0);
        model.closePath();

        return model;
    }, [params.add_storage_check, params.p_b_c_b_l_b, params.add_left_back_lean_porch, params.lean_p_h, params.lean_p_d, offsetHeight, params.p_b_c_b_l, sideWallCloseSize])

    /**********************cutting hole using CSG for Back************************/ 

    const storageBackWall = useMemo(() => {

        let wainscot, trim;

        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModel, extrudeSettings(0.22)));

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.leftLeanStoragePosition, 0, -0.7 - params.lean_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.position.set((params.lean_p_d / 2 + 0.5), 0, (params.p_w / 2 + params.lean_p_w + 0.05 + wallThickness))
        meshBackDelModel_Temp.rotation.y = -Math.PI / 2
        meshBackDelModel_Temp.updateMatrixWorld();

        let meshTrimModel_Temp = meshTrimModel.clone();
        // meshTrimModel_Temp.position.set(-parseInt(params.add_storage) - 0.1 - offset, 0, -0.02)
        meshTrimModel_Temp.updateMatrixWorld();

        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set(params.lean_p_d / 2 + 0.185, 3 , 0.05)
        meshBackWainscotModel_Temp.updateMatrixWorld();
    
        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);
    
        const backWainscotSideDelModel_CSG = meshBackWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const backWainscotTrimDelModel_CSG = backWainscotSideDelModel_CSG.subtract(meshBackDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(backWainscotTrimDelModel_CSG,new THREE.Matrix4());
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGBackWainscotModel.geometry;
        trim = meshTrimDelModel.geometry;

        return {wainscot, trim};
    }, [params.lean_p_d, params.lean_p_w, params.p_w, const_var.newDoorsArray, params.lean_p_pos, params.leftLeanStoragePosition, backWallVrTrimModel])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_l === 'Open' || typeof(params.p_b_c_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.lean_p_h + 0.15;
            } else {
                tempWallCloseSize = params.lean_p_h;
            }
        } else if (params.p_b_c_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.lean_p_h - 3 * params.p_b_c_b_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_l, params.lean_p_h, params.p_r_s])

    return (
        <group  position={[-(params.p_w / 2 + params.lean_p_w + 0.05 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            <mesh name="back-wall-trim" geometry={storageBackWall.trim} position={[0, 0, -0.015]}>
                <MaterialTrim visibleSection={"leftLean"} />
            </mesh>
       
            {params.p_w_c_n == true &&
                <mesh name="wainscotTrim" geometry={storageBackWall.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"leftlean"}/>
                </mesh>
            }
               
        </group>
    )
}

export default TrimModel